import React from 'react';
import { useRecordContext } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';

const priorityConfig = {
    low: { label: 'Low', color: 'info' },
    normal: { label: 'Normal', color: 'default' },
    high: { label: 'High', color: 'warning' },
    urgent: { label: 'Urgent', color: 'error' }
};

const PriorityField = ({ source = 'priority', size = 'small' }) => {
    const record = useRecordContext();
    if (!record || !record[source]) {
        return null;
    }

    const priority = record[source];
    const config = priorityConfig[priority] || { label: priority, color: 'default' };

    return (
        <ChipField
            source={source}
            record={{ [source]: config.label }}
            size={size}
            sx={getChipColors(config.color)}
        />
    );
};

export default PriorityField;
